import { useState } from "react";
import { NavLink } from "./NavLink";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-dark-bg py-4 px-6 sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        <NavLink to="/" className="flex items-center">
          <img src="/logo192.png" alt="Orbit" className="h-12 w-auto" />
        </NavLink>

        {/* Hamburger button - visible on mobile */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
        >
          <span
            className={`block w-6 h-0.5 bg-white transition-all ${
              isOpen ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-white transition-all ${
              isOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-white transition-all ${
              isOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>

        {/* Navigation - hidden on mobile, visible on md+ */}
        <nav
          className={`${
            isOpen ? "flex" : "hidden"
          } md:flex absolute md:static top-full left-0 right-0 md:right-auto flex-col md:flex-row gap-4 md:gap-8 bg-dark-bg md:bg-transparent p-6 md:p-0 items-center md:items-auto`}
        >
          <NavLink
            to="/"
            className="text-white hover:text-primary/80 transition-colors font-bold"
            activeClassName="!text-primary"
            onClick={() => setIsOpen(false)}
          >
            Om oss
          </NavLink>
          <NavLink
            to="/how-it-works"
            className="text-white hover:text-primary/80 transition-colors font-bold"
            activeClassName="!text-primary"
            onClick={() => setIsOpen(false)}
          >
            Hur funkar det?
          </NavLink>
          <NavLink
            to="/contact"
            className="text-white hover:text-primary/80 transition-colors font-bold"
            activeClassName="!text-primary"
            onClick={() => setIsOpen(false)}
          >
            Kontakta oss
          </NavLink>
          <NavLink
            to="/faq"
            className="text-white hover:text-primary/80 transition-colors font-bold"
            activeClassName="!text-primary"
            onClick={() => setIsOpen(false)}
          >
            FAQ
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
